import React, { createContext, useState, useEffect } from 'react';
import { getCurrentUser } from '../api/auth';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');

    if (token) {
      // If we have stored user data, use it immediately
      if (storedUser) {
        try {
          setUser(JSON.parse(storedUser));
        } catch (error) {
          console.error('Error parsing stored user data:', error);
        }
      }

      // Still verify with API in background
      getCurrentUser()
        .then((response) => {
          console.log('getCurrentUser response:', response);
          const userData = response.agent || response.subadmin || response.ca || response.superadmin;
          console.log('Setting user data:', userData);
          setUser(userData);
          // Update localStorage with fresh data
          localStorage.setItem('user', JSON.stringify(userData));
        })
        .catch((error) => {
          console.error('Token verification failed:', error);
          // Remove automatic logout on token verification failure
          // Only clear data if it's a 401 error (invalid token)
          if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            setToken(null);
            setUser(null);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      // No token, clear any stored user data
      localStorage.removeItem('user');
      setUser(null);
      setLoading(false);
    }
  }, [token]);

  const login = (userData, tokenValue) => {
    setToken(tokenValue);
    setUser(userData);
    // Save user data to localStorage on login
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user'); // Remove user data on logout
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isCollapsed, setIsCollapsed }}>
      {children}
    </AuthContext.Provider>
  );
};
